<div *ngIf="form">
  <form
    bindQueryParamsToForm
    [bindEnabled]="bindEnabled"
    [questionsToBind]="questions"
    #myForm="ngForm"
    (ngSubmit)="onSubmit()"
    [formGroup]="form"
  >
    <div *ngFor="let question of questions" class="form-group">
      <app-question
        [question]="question"
        [questions]="questions"
        [form]="form"
        (hasChanged)="onChange($event)"
      ></app-question>
    </div>

    <!-- Needed for adding table inside form grid -->
    <div (click)="$event.preventDefault()">
      <ng-content select="[dynamic-form-table]"></ng-content>
    </div>
  </form>
  <div *ngIf="showButtons" class="form-group-button text-center">
    <button
      *ngIf="editBtn.show | dynamicPipe: editBtn?.hiddenPipe?.name:editBtn?.hiddenPipe?.args"
      (click)="editBtn.onClick()"
      class="btn btn-secondary"
    >
      {{ editBtn.label }}
    </button>
    <button (click)="onSubmit()" [disabled]="isDisabled()" class="btn btn-primary">
      {{ saveLabel }}
    </button>
    <button
      *ngIf="customBtn"
      (click)="customBtn.onClick()"
      [disabled]="customBtn.disabled | applyFunctionOrValue: customBtn.disabled"
      class="btn btn-secondary customBtn"
    >
      <div style="display: flex">
        {{ customBtn.label }}

        <mat-icon *ngIf="customBtn.warnMessage" color="warn" [matTooltip]="customBtn.warnMessage">warning</mat-icon>
      </div>
    </button>
  </div>
</div>
